// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 488 ? "test-mode-panel" : chunkId) + "." + {"488":"70c9870a","641":"2a3e4dbc","833":"9fa8bbae"}[chunkId] + ".chunk.js";
};